import { Alert, Link, Stack, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { FlatCard, InvoiceDetailsReadonly } from '../../components';
import type { Customer } from '~/subscription-management/api/common/model/customer';
import { shouldMigrateAddress } from '../../utils/migrated-customers.utils';

const CARD_WIDTH = 300;

const S = {
  Card: styled(FlatCard)`
    width: ${CARD_WIDTH}px;
  `,
  Alert: styled(Alert)`
    min-width: ${CARD_WIDTH}px;
    width: ${CARD_WIDTH}px;
  `,
  TitleRow: styled(Stack)`
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${tokens.spacer.x1};
  `,
};

interface Props {
  customer: Customer;
  onEdit: () => void;
}

export const InvoiceDetailsInfo = ({ customer, onEdit }: Props): JSX.Element => {
  const { t } = useTranslationWithPrefix('checkout:invoices.migrate-address-alert');

  if (shouldMigrateAddress(customer.billingAddress)) {
    return (
      <S.Alert kind="warning">
        <S.TitleRow spacing="x0">
          <Text textType="subtitle2">{t('title')}</Text>
          <Link as="button" kind="standalone" onClick={onEdit}>
            {t('update')}
          </Link>
        </S.TitleRow>
        <Text>{t('description')}</Text>
      </S.Alert>
    );
  }

  return (
    <S.Card>
      <InvoiceDetailsReadonly customer={customer} truncateAddress asTitle onEdit={onEdit} />
    </S.Card>
  );
};
